/* eslint-disable consistent-return */
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NavigateFunction } from "react-router-dom";
import { ReactComponent as TradingIcon } from "../../assets/svg/bar-chart.svg";
import { ReactComponent as PortfolioIcon } from "../../assets/svg/pie-chart.svg";
import { ReactComponent as RewardsIcon } from "../../assets/svg/rewards.svg";
import { PageEndpointEnum } from "../../enums/endpoint";
import { Container, Tab } from "./style";

enum MobileTabsEnum {
  Trading = "Trading",
  // Strategies = "Strategies",
  Portfolio = "Portfolio",
  // Marginx = "MarginX",
  // Referrals = "Referrals",
}

const icon: { [key in MobileTabsEnum]: React.FunctionComponent } = {
  [MobileTabsEnum.Trading]: TradingIcon,
  // [MobileTabsEnum.Strategies]: StrategiesIcon,
  [MobileTabsEnum.Portfolio]: PortfolioIcon,
  // [MobileTabsEnum.Marginx]: MarginXIcon,
  // [MobileTabsEnum.Referrals]: RewardsIcon,
};

interface IMobileTabsProps {
  currentPage: PageEndpointEnum;
  navigate: NavigateFunction;
}

function MobileTabs({ currentPage, navigate }: IMobileTabsProps) {
  const { t } = useTranslation("app", { keyPrefix: "MobileTabs" });

  const selectedTab = useMemo(() => {
    switch (currentPage) {
      case PageEndpointEnum.PORTFOLIO:
        return MobileTabsEnum.Portfolio;
      // case PageEndpointEnum.REFERRALS:
      //   return MobileTabsEnum.Referrals;
      // case PageEndpointEnum.MARGINX:
      //   return MobileTabsEnum.Marginx;
      case PageEndpointEnum.STRATEGIES:
      case PageEndpointEnum.ACCOUNT:
      case PageEndpointEnum.TRADING:
      case PageEndpointEnum.HISTORICAL:
      case PageEndpointEnum.SETTINGS:
      case PageEndpointEnum.SETTLEMENT_HISTORY:
      case PageEndpointEnum.REF_LINK:
      case PageEndpointEnum.RFQ:
        return MobileTabsEnum.Trading;
    }
  }, [currentPage]);

  const navigateTo = useCallback(
    (tab: MobileTabsEnum) => {
      let page = PageEndpointEnum.TRADING;
      switch (tab) {
        case MobileTabsEnum.Portfolio:
          page = PageEndpointEnum.PORTFOLIO;
          break;
        case MobileTabsEnum.Trading:
          page = PageEndpointEnum.TRADING;
          break;
        // case MobileTabsEnum.Referrals:
        //   page = PageEndpointEnum.REFERRALS;
        //   break;
        // case MobileTabsEnum.Marginx:
        //   page = PageEndpointEnum.MARGINX;
        //   break;
      }
      navigate(page);
    },
    [navigate]
  );

  return (
    <Container>
      {Object.values(MobileTabsEnum).map((v) => {
        const Icon = icon[v];
        return (
          <Tab
            key={v}
            $isSelected={v === selectedTab}
            onClick={() => navigateTo(v)}
          >
            <Icon />
            <span>{t(v.toLowerCase())}</span>
          </Tab>
        );
      })}
    </Container>
  );
}

export default MobileTabs;
